import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Control } from '../../_models/control';
import { ControlService } from '../../_services/control.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { FormaDesembolsoService } from '../../_services/forma-desembolso.service';
import { forkJoin} from 'rxjs';
import { FormaDesembolso } from '../../_models/forma-desembolso';
import { ExcepcionGMF } from '../../_models/excepcion-gmf';
import { ExcepcionGMFTipoCredito } from '../../_models/excepcion-gmf-tipo-credito';
import { ExcepcionGMFFormaDesembolso } from '../../_models/excepcion-gmf-forma-desembolso';
import { ExcepcionGMFFormaDesembolsoService } from '../../_services/excepcion-gmf-forma-desembolso.service';
import { ExcepcionGMFTipoCreditoService } from '../../_services/excepcion-gmf-tipo-credito.service';
import { ExcepcionGmfService } from '../../_services/excepcion-gmf.service';

@Component( {
  selector: 'app-excepciones-gmf-cofiguracion-destinos',
  templateUrl: 'excepciones-gmf-configuracion-destinos.component.html'
} )

export class ExcepcionesGmfConfiguracionDestinosComponent implements OnInit {

  @Input() excepcionGMF: ExcepcionGMF;
  excepcionGMFTipoCredito: ExcepcionGMFTipoCredito;
  excepcionGMFFormaDesembolso: ExcepcionGMFFormaDesembolso;
  carInformacionInicial = true;
  guardando = false;
  formularioFormaDesembolso: FormGroup;
  formularioPorCuentaAhorros: FormGroup;
  formularioPorTipoCredito: FormGroup;
  submitted = false;
  formasDesembolso: FormaDesembolso [] = [];
  lisFormasDesembolso: SelectItem[] = [];
  lisPrimerBeneficiariosCruzados: SelectItem[] = [];
  lisBeneficiarios: SelectItem[] = [];
  lisTiposCreditos: SelectItem[] = [];

  constructor( private conControlesServicio: ControlService,
               private formasDesembolsoServicio: FormaDesembolsoService,
               private excepcionGMFServicio: ExcepcionGmfService,
               private excepcionGMFFormaDesembolsoServicio: ExcepcionGMFFormaDesembolsoService,
               private excepcionGMFTipoCreditoServicio: ExcepcionGMFTipoCreditoService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private lisServicio: ListaService,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {
    if ( this.excepcionGMF ) {
      this.carServiciosIniciales();
    }
  }

  carServiciosIniciales() {
    forkJoin( this.excepcionGMFServicio.obtenerPorId( this.excepcionGMF.idExcepcionGMF ),
      this.formasDesembolsoServicio.listadoHabilitado(),
      this.lisServicio.getMasterDetails('ListasPrimerBeneficiariosCruzados'),
      this.lisServicio.getMasterDetails('ListasBeneficiarios'),
      this.lisServicio.getMasterDetails('ListasTiposCreditos'),
      this.excepcionGMFFormaDesembolsoServicio.obtenerPorIdExcepcionGMF( this.excepcionGMF.idExcepcionGMF ),
      this.excepcionGMFTipoCreditoServicio.obtenerPorIdExcepcionGMF( this.excepcionGMF.idExcepcionGMF )).subscribe(
      ([ excep, formasDesembolso, lisPrimerBenefiCruz, lisBeneficiarios, lisTiposCreditos, excepFormaDes, excepTipoCred]) => {

        /**limpiamos las listas*/
        this.lisFormasDesembolso = [];
        this.lisPrimerBeneficiariosCruzados = [];
        this.lisBeneficiarios = [];
        this.lisTiposCreditos = [];
        /** asignamos los datos de los servicios*/
        this.excepcionGMF = excep;
        this.formasDesembolso = formasDesembolso;
        this.excepcionGMFFormaDesembolso = excepFormaDes;
        this.excepcionGMFTipoCredito = excepTipoCred;

        this.lisFormasDesembolso.push( { label: 'Seleccione', value: null });
        this.formasDesembolso.map( (s: FormaDesembolso) => {
          this.lisFormasDesembolso.push( { label: s.nombre, value: s.idFormaDesembolso});
        });

        this.lisPrimerBeneficiariosCruzados.push( { label: 'Seleccione', value: null } );
        lisPrimerBenefiCruz.map( (s: ListaItem) => {
          this.lisPrimerBeneficiariosCruzados.push( { label: s.nombre, value: s.idLista});
        });

        this.lisBeneficiarios.push( { label: 'Seleccione', value: null } );
        lisBeneficiarios.map( (s: ListaItem) => {
          this.lisBeneficiarios.push( { label: s.nombre, value: s.idLista});
        });

        this.lisTiposCreditos.push( { label: 'Seleccione', value: null } );
        lisTiposCreditos.map( (s: ListaItem) => {
          this.lisTiposCreditos.push( { label: s.nombre, value: s.idLista});
        });

        this.cargarFormularios();
        this.carInformacionInicial = false;
      }
    );
  }

  cargarFormularios() {
    /**Formulario, se usan 3 formulario para manipular el DOM*/

    this.formularioPorCuentaAhorros = this.fb.group(
      {  indicadorManejaCtaAhorros: this.excepcionGMF  ? this.excepcionGMF.indicadorManejaCtaAhorros :  null }
    );

    this.formularioPorTipoCredito = this.fb.group({
      idTipoCredito: (this.excepcionGMFTipoCredito && this.excepcionGMFTipoCredito.indicadorHabilitado) ? this.excepcionGMFTipoCredito.idTipoCredito : null,
      }
    );

    this.formularioFormaDesembolso = this.fb.group( {
      idFormaDesembolso: [(this.excepcionGMFFormaDesembolso && this.excepcionGMFFormaDesembolso.indicadorHabilitado ) ?
        this.excepcionGMFFormaDesembolso.idFormaDesembolso : null, [Validators.required]],
      idBeneficiario: [( this.excepcionGMFFormaDesembolso && this.excepcionGMFFormaDesembolso.indicadorHabilitado ) ?
        this.excepcionGMFFormaDesembolso.idBeneficiario : null, [Validators.required]],
      idPrimerBeneficiario: [( this.excepcionGMFFormaDesembolso && this.excepcionGMFFormaDesembolso.indicadorHabilitado ) ?
        this.excepcionGMFFormaDesembolso.idPrimerBeneficiario : null, [Validators.required]],
      idCruzado: [( this.excepcionGMFFormaDesembolso && this.excepcionGMFFormaDesembolso.indicadorHabilitado ) ?
        this.excepcionGMFFormaDesembolso.idCruzado : null, [Validators.required]],
    } );
  }

  onSubmit() {
    this.submitted = true;
    /** Se verifica si alguna de las 3 secciones tiene válido el formulario*/
    if ( this.formularioFormaDesembolso.valid || this.formularioPorTipoCredito.valid
    || this.formularioPorCuentaAhorros.valid) {
      if ( this.validacionGuardado() ) {
        /**Valida si la sección formDes se llenó y que sea válida*/
        if ( this.seccionInicialDirty() === false || ( this.verificarSeccionInicial())) {
        this.guardando = true;
        /**Creamos el dto*/
        const dtoParaEnviar = {
          idExcepcionGMF: this.excepcionGMF.idExcepcionGMF,
          codigo: this.excepcionGMF.codigo,
          nombre: this.excepcionGMF.nombre,
          descripcion: this.excepcionGMF.descripcion,
          indicadorManejaCtaAhorros: this.formularioPorCuentaAhorros.value.indicadorManejaCtaAhorros,
          indicadorHabilitado: this.excepcionGMF.indicadorHabilitado,
          auditoriaUsuario: this.excepcionGMF.auditoriaUsuario,
          auditoriaFecha: this.excepcionGMF.auditoriaFecha,
          idFormaDesembolso:  this.formularioFormaDesembolso.value.idFormaDesembolso,
          idCruzado: this.formularioFormaDesembolso.value.idCruzado,
          idPrimerBeneficiario: this.formularioFormaDesembolso.value.idPrimerBeneficiario,
          idBeneficiario: this.formularioFormaDesembolso.value.idBeneficiario,
          idTipoCredito: this.formularioPorTipoCredito.value.idTipoCredito,
          idExcepcionGMFTipoCredito: this.excepcionGMFTipoCredito ? this.excepcionGMFTipoCredito.idExcepcionGMFTipoCredito : null,
          idExcepcionesGMFFormasDesembolsos: this.excepcionGMFFormaDesembolso ? this.excepcionGMFFormaDesembolso.idExcepcionesGMFFormasDesembolsos : null,
        };
        this.excepcionGMFServicio.saveExcepcionesCreditosDesembolsos( dtoParaEnviar ).subscribe(
        res => {
          this.navServicio.setMesage(1);
          this.guardando = false;
          this.carServiciosIniciales();
        }, error1 => {
          this.navServicio.setMesage(3);
        });

        }
      } else {
        /**Mensaje para cuando no se ha diligenciado ninguno de los formularios*/
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('EXCEPCIONESGMF.MSG_LLENARSECCION')
        });
      }
    }
  }

  validacionGuardado(): boolean {
    /**banderas para validar cada caso */
    let cuentaAhorro = false;
    let porTipoCredito = false;
    let formaDesembolso = false;
    /**Se verifica que el indicadorCtaAhorros esté habilitado*/
    if ( this.formularioPorCuentaAhorros && this.formularioPorCuentaAhorros.value.indicadorManejaCtaAhorros ) {
      cuentaAhorro = this.formularioPorCuentaAhorros.value.indicadorManejaCtaAhorros;
    }
    /**Se verifica que el inidicador porTipoCredito esté habilitado*/
    if ( this.formularioPorTipoCredito && Number (this.formularioPorTipoCredito.value.idTipoCredito) ) {
      porTipoCredito = true;
    }
    /**Se verifica que el formularioFormasDesembolso esté diligenciado*/
    if ( this.formularioFormaDesembolso.valid  ) {
      formaDesembolso = true;
    }
    /** Se evalua si se cumple alguna de las opciones*/
    if ( cuentaAhorro || porTipoCredito || formaDesembolso ) {
      return true;
    }
    return false;
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  /**Valida que el formulario formaDesembolso sea válido*/
  verificarSeccionInicial(): boolean {
    if ( this.seccionInicialDirty()) {
      if ( this.fFormaDes.idCruzado.value && this.fFormaDes.idPrimerBeneficiario.value &&
        this.fFormaDes.idBeneficiario.value && this.fFormaDes.idFormaDesembolso ) {
        return true;
      }
    }
    return  false;
  }

  /**Retorna true si alguno de los controles del formulario tiene un valor diferente a null*/
  seccionInicialDirty(): boolean {
    if ( this.fFormaDes.idCruzado.value || this.fFormaDes.idPrimerBeneficiario.value ||
      this.fFormaDes.idBeneficiario.value || this.fFormaDes.idFormaDesembolso.value ) {
      return true;
    }
    return false;
  }

  /**Obtener controles de formularios*/
  get fCuentaAho() {
    return this.formularioPorCuentaAhorros.controls;
  }
  get fPorTipoCred() {
    return this.formularioPorTipoCredito.controls;
  }
  get fFormaDes() {
    return this.formularioFormaDesembolso.controls;
  }
}
